import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t('testimonials.t1Quote'),
    author: 'Carlos M.',
    location: 'Tremont, Bronx'
  }, {
    quote: t('testimonials.t2Quote'),
    author: 'Roberto A.',
    location: 'East Tremont'
  }, {
    quote: t('testimonials.t3Quote'),
    author: 'Miguel T.',
    location: 'Bronx NY'
  }, {
    quote: t('testimonials.t4Quote'),
    author: 'David R.',
    location: 'West Farms'
  }];
  return <Section className="bg-barber-black" data-id="element-406">
      <div className="text-center mb-16" data-id="element-407">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-barber-text uppercase mb-4" data-id="element-408">
          {t('testimonials.heading1')}{' '}
          <span className="text-barber-gold" data-id="element-409">{t('testimonials.heading2')}</span>
        </h2>
        <div className="w-16 h-1 bg-barber-gold mx-auto" data-id="element-410"></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-411">
        {testimonials.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-barber-gray p-8 rounded-sm border border-barber-lightGray relative" data-id="element-412">
            <div className="absolute top-6 right-8 text-barber-lightGray text-6xl font-heading leading-none" data-id="element-413">
              "
            </div>
            <div className="flex gap-1 mb-4" data-id="element-414">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-barber-gold fill-barber-gold" data-id="element-415" />)}
            </div>
            <p className="text-lg text-barber-text mb-6 relative z-10 italic" data-id="element-416">
              "{item.quote}"
            </p>
            <div className="border-t border-barber-lightGray pt-4" data-id="element-417">
              <p className="font-heading font-bold text-barber-gold tracking-wider uppercase" data-id="element-418">
                {item.author}
              </p>
              <p className="text-sm text-barber-muted" data-id="element-419">{item.location}</p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}